import layout from '../layout'
export default function makeFeelingRoutes({
  contentType,
  components: { FeelingListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list/`,
          component: FeelingListingContainer,
          props: {
            contentType,
          }
        },
      ]
    },
  ];
}
